export const TravelAreaIcon = ({ color = "#DBBE78", size = 18, ...props }) => (
    <svg
        width={size}
        height={size * (15 / 18)}
        viewBox="0 0 18 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M2.65667 1.75875C2.84 1.2425 3.35333 0.875 3.95833 0.875H14.0417C14.6467 0.875 15.1508 1.2425 15.3433 1.75875L17.25 7V14C17.25 14.4812 16.8375 14.875 16.3333 14.875H15.4167C14.9125 14.875 14.5 14.4812 14.5 14V13.125H3.5V14C3.5 14.4812 3.0875 14.875 2.58333 14.875H1.66667C1.1625 14.875 0.75 14.4812 0.75 14V7L2.65667 1.75875ZM13.125 10.5C13.8858 10.5 14.5 9.91375 14.5 9.1875C14.5 8.46125 13.8858 7.875 13.125 7.875C12.3642 7.875 11.75 8.46125 11.75 9.1875C11.75 9.91375 12.3642 10.5 13.125 10.5ZM4.875 10.5C5.63583 10.5 6.25 9.91375 6.25 9.1875C6.25 8.46125 5.63583 7.875 4.875 7.875C4.11417 7.875 3.5 8.46125 3.5 9.1875C3.5 9.91375 4.11417 10.5 4.875 10.5ZM14.6742 5.25L13.7208 2.625H4.28833L3.335 5.25H14.6742Z"
            fill={color}
        />
    </svg>
);
